import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { AppLangCode } from '@libs/types';
import { JurisdictionsEnum } from '@libs/backend-common';
import { CustomSelectModal, CustomSelectOption, CustomSelectOptionWrapper, ListContainer, } from './styles';
import { getLanguageOptions } from './language-options/LanguageOptions';
const LanguageSwitcher = ({ changeLanguage, selectedLanguage, className, title, customOptions, jurisdictionId, }) => {
    const handleOptionChange = useCallback((value) => {
        const val = value;
        changeLanguage(val);
    }, [changeLanguage]);
    const customSelectRenderOption = useCallback((opt, index) => {
        const handleChange = () => {
            if (opt.disabled)
                return;
            handleOptionChange(opt.value);
        };
        const isCyrillic = [AppLangCode.RU, AppLangCode.UA].includes(opt.value);
        return (_jsx(ListContainer, { children: _jsx(CustomSelectOptionWrapper, { selectedOptionCheck: opt.value !== selectedLanguage, children: _jsx(CustomSelectOption, { isCyrillic: isCyrillic, icon: opt.icon, label: opt.label, value: opt.value, onClick: handleChange, isSelected: opt.value === selectedLanguage, disabled: !!opt?.disabled, description: opt?.description, isRadioIconVisible: false }) }, index) }, index));
    }, [handleOptionChange, selectedLanguage]);
    const options = getLanguageOptions(jurisdictionId);
    if (jurisdictionId === JurisdictionsEnum.EU)
        return null;
    return (_jsx(CustomSelectModal, { className: className, selectedValue: selectedLanguage, onChange: handleOptionChange, options: customOptions || options, renderOption: customSelectRenderOption, title: title }));
};
export default LanguageSwitcher;
//# sourceMappingURL=LanguageSwitcher.js.map